
<div id="app">
  <ng-container *ngIf="list">
    <app-common-header></app-common-header>

    <!-- main -->
    <main class="main">
      <section class="wrap-history">
        <a href="/#/history" class="btn-winning-history">当選履歴</a>
      </section>

      <section class="wrap-kuji">
        <ng-container *ngIf="list.kujis.length; else noData">
          <ul class="list-kuji">
            <ng-container *ngFor="let kuji of list.kujis">
                  <li class="list-kuji-item">
                  <!--
                    ボタンタイプ20 = 外部リンクへ遷移
                    ボタンタイプ20以外 = アプリホワイトリスト用にクエリパラメータpage=detail, id={くじID}リンクを設置
                   -->
                  <a class="list-kuji-link"
                    [href]="kuji.button_type === 20 ? kuji.move_to : '/#/detail2/' + kuji.id"
                    target="_blank"
                    (click)="onClickLink($event,kuji.button_type === 20 ? kuji.move_to : domainPath + '/#/detail2/' + kuji.id)" 
                  >
                    <div class="item-kuji">

                      <div class="kuji-conditions">
                        <!-- 掲載期間バッチ -->
                        <ng-container *ngIf="kuji.badge_type !== 0">
                          <span class="conditions-term">
                            <ng-container *ngIf="kuji.badge_type === 1">NEW</ng-container>
                            <ng-container *ngIf="kuji.badge_type === 2">まもなく終了</ng-container>
                          </span>
                        </ng-container>

                        <!-- くじ簡易説明​ -->
                        <ng-container *ngIf="kuji.category_text">
                          <span class="conditions-frequency">{{ kuji.category_text }}</span>
                        </ng-container>
                      </div>

                      <!-- 残りくじ引き回数 -->
                      <ng-container *ngIf="kuji.possible_count > 0">
                        <div class="conditions-remaining">
                          <span>{{ (kuji.possible_count < 99) ? kuji.possible_count : 99 }}</span>
                        </div>
                      </ng-container>

                      <!-- サムネイル -->
                      <div class="conditions-img">
                        <img src="{{ cdnPath }}/content/{{ kuji.id }}/img/thumbnail.png" alt="{{ kuji.id }}">
                      </div>

                      <!-- くじびきボタン -->
                      <div class="btn-kuji" *ngIf="kuji.button_type === 1">くじをひく</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 2">明日も参加してね</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 3">参加ありがとう</div>
                      <div class="btn-kuji" *ngIf="kuji.button_type === 10">エントリーする</div>
                      <div class="btn-kuji" *ngIf="kuji.button_type === 11">参加条件を確認する</div>
                      <div class="btn-kuji" *ngIf="kuji.button_type === 20">くじを確認する</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 90">終了しました</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 91">終了しました</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 92">終了しました</div>
                      <div class="btn-kuji btn-close" *ngIf="kuji.button_type === 99">終了しました</div>

                      <div class="conditions-period">
                        <!-- 開催期間ラベル -->
                        <div class="conditions-held">
                          <div class="">
                            <div class="held-title" *ngIf="kuji.label_date">{{ kuji.label_date }}</div>
                            <div class="held-title" *ngIf="!kuji.label_date">開催期間</div>
                          </div>
                          <div class="held-period"><span class="">{{ kuji.start_date | dateParse | date: 'MM/dd' }}</span>&nbsp;-&nbsp;<span class="">{{ kuji.end_date | dateParse | date: 'MM/dd'  }}</span></div>
                        </div>

                        <!-- 購入対象期間ラベル -->
                        <!-- 「参加条件あり」以外は非表示 -->
                        <div class="conditions-entry" *ngIf="kuji.type === 'entry'">
                          <div class="">
                            <div class="entry-title" *ngIf="kuji.label_aggregation_date">{{ kuji.label_aggregation_date }}</div>
                            <div class="entry-title" *ngIf="!kuji.label_aggregation_date">購入対象期間</div>
                          </div>
                          <div class="entry-period"><span class="">{{ kuji.aggregation_start_date | dateParse | date: 'MM/dd' }}</span>&nbsp;-&nbsp;<span class="">{{ kuji.aggregation_end_date | dateParse | date: 'MM/dd' }}</span></div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
            </ng-container>
          </ul>
        </ng-container>

        <ng-template #noData>
          <div class="wrap-nothing">
            <div class="nothing">
              開催中のくじはありません
            </div>
          </div>
        </ng-template>
      </section>

      <section class="wrap-bnr">
        <ng-container *ngIf="list.banners">
          <ul class="list-bnr">
            <ng-container *ngFor="let banner of list.banners">
              <li class="list-bnr-item">
                <a class="bnr" href="{{ banner.move_to }}" target="blank">
                  <img src="{{ cdnPath }}/content/{{ banner.id }}/img/banner.png" alt="{{ banner.name }}">
                </a>
              </li>
            </ng-container>
          </ul>
        </ng-container>
      </section>
    </main>
    <!-- /main -->

    <app-common-footer></app-common-footer>
  </ng-container>

  <ng-container *ngIf="error">
    <app-error-page [error]="error"></app-error-page>
  </ng-container>

  <ng-container *ngIf="(isListLoading$ | async)">
    <app-loading></app-loading>
  </ng-container>
</div>
